<section class="login-registration-page">
  <form *ngIf="form" class="login-registration-form" [formGroup]="form" (ngSubmit)="login()">
    <p class="main-form-title" data-test-id="login-form-title">
      {{ 'LOGIN_FORM_TEXT' | translate }}
    </p>
    <div class="mb-3" data-test-id="wrap-login-form-email">
      <label class="form-label" for="email" data-test-id="email-label">
        {{ 'LOGIN_FORM_EMAIL_LABEL' | translate }} *
      </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('email') }"
        type="email"
        formControlName="email"
        id="email"
        data-test-id="login-form-email"
        placeholder="{{ 'FORM_EMAIL_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="login-form-email-error">
        {{ getErrorDescriptionId('email') | translate }}
      </small>
    </div>
    <div class="password-group" data-test-id="wrap-login-form-password">
      <app-eye-password
        [form]="form"
        [errorTexting]="texting('password-error', oldPasswordErrorText)"
        [dataTestId]="'login-form-password'"
        [invalid]="isPasswordFieldInvalid('password')"
      ></app-eye-password>
    </div>
    <span
      class="forgot-password text-primary"
      data-test-id="login-form-forgot-password"
      [routerLink]="'/reset-password'"
    >
      {{ 'LOGIN_FORM_FORGOT_PASSWORD_HINT' | translate }}
    </span>
    <small class="form-text text-muted mt-2 d-block"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
    <div class="submit-button">
      <button appLongOperation class="btn btn-primary text-white" type="submit" data-test-id="login-form-login-btn">
        {{ 'LOGIN_FORM_SUBMIT_BTN' | translate }}
      </button>
    </div>
    <span class="sign-up-text text-muted">
      {{ 'LOGIN_FORM_SIGN_UP_TEXT' | translate }}
    </span>
    <span class="sign-up-link text-primary" data-test-id="login-form-sign-up-link" [routerLink]="'/sign-up'">
      {{ 'LOGIN_FORM_SIGN_UP_LINK' | translate }}
    </span>
  </form>
</section>
